export default __webpack_public_path__ + "bml-characteristic5.3c0234d.png";